<div class="infoText">
  <span class="infoIcon">i</span>
  <div>
    Für den Widerruf bei
    <span class="bankDisplayName">{{ bankDisplayName }}</span> werden Sie direkt
    auf das Widerrufsformular der Bank weitergeleitet.
  </div>
</div>
<div class="row align-right">
  <button type="button" (click)="redirectToBank()">
    Zu <span class="bankDisplayName">{{ bankDisplayName }}</span> wechseln
  </button>
</div>
